import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f1c5cfa")

_pushScopeId("data-v-2f1c5cfa")
const _hoisted_1 = { class: "infoContainer gt-sm" }
const _hoisted_2 = { class: "SupplyContent" }
const _hoisted_3 = { class: "marketOverview-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = { class: "marketOverview-data" }
const _hoisted_6 = { class: "marketOverview-title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "marketOverview-data" }
const _hoisted_9 = { class: "marketOverview-title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "marketOverview-data" }
const _hoisted_12 = {
  key: 0,
  class: "launchpadBg bonfidaImg"
}
const _hoisted_13 = {
  key: 1,
  class: "launchpadBg xSolImg"
}
const _hoisted_14 = {
  key: 2,
  class: "launchpadBg larixlImg"
}
const _hoisted_15 = {
  key: 3,
  class: "launchpadBg stepnImg"
}
const _hoisted_16 = {
  key: 4,
  class: "launchpadBg stepImg"
}
const _hoisted_17 = { class: "myPositionOverview" }
const _hoisted_18 = { class: "myPositionOverview-limit" }
const _hoisted_19 = { class: "myPositionOverview-limit-refresh" }
const _hoisted_20 = { class: "myPositionOverview-limit-details" }
const _hoisted_21 = { class: "myPositionOverview-limit-borrow" }
const _hoisted_22 = {
  class: "titleColor",
  style: {"padding-right":"2px"}
}
const _hoisted_23 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_24 = { class: "dataColor" }
const _hoisted_25 = { class: "myPositionOverview-limit-liquidation" }
const _hoisted_26 = {
  class: "titleColor",
  style: {"padding-right":"2px"}
}
const _hoisted_27 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_28 = { class: "dataColor" }
const _hoisted_29 = { class: "appInfoContainer lt-md" }
const _hoisted_30 = { class: "appInfoContainer-supply" }
const _hoisted_31 = { class: "supplyAndBorrow" }
const _hoisted_32 = { class: "body" }
const _hoisted_33 = { class: "body-item" }
const _hoisted_34 = { style: {"font-size":"15px"} }
const _hoisted_35 = { class: "body-item" }
const _hoisted_36 = { style: {"font-size":"15px"} }
const _hoisted_37 = { class: "body-item" }
const _hoisted_38 = { style: {"font-size":"15px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dashboard = _resolveComponent("Dashboard")
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")
  const _component_q_tooltip = _resolveComponent("q-tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: ["marketOverview", _ctx.poolBackground]
        }, [
          _createVNode("div", null, [
            _createVNode("p", _hoisted_3, _toDisplayString(_ctx.t('market.supplyBorrow')), 1),
            _hoisted_4,
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.formatDollars(_ctx.allMarketSupplyAndBorrow.toString())), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('market.totalSupply')), 1),
            _hoisted_7,
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.formatDollars(_ctx.poolTotalSupply.toString())), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.t('market.totalBorrow')), 1),
            _hoisted_10,
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDollars(_ctx.poolTotalBorrow.toString())), 1)
          ]),
          (_ctx.poolType==='bonfida')
            ? (_openBlock(), _createBlock("div", _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.poolType==='xSol')
            ? (_openBlock(), _createBlock("div", _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.poolType==='larix')
            ? (_openBlock(), _createBlock("div", _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.poolType==='stepn')
            ? (_openBlock(), _createBlock("div", _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.poolType==='step')
            ? (_openBlock(), _createBlock("div", _hoisted_16))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode("div", _hoisted_17, [
          (_ctx.poolType==='xSol')
            ? (_openBlock(), _createBlock(_component_Dashboard, {
                key: 0,
                device: "PC",
                "page-type": _ctx.pageType,
                "pool-type": _ctx.poolType
              }, null, 8, ["page-type", "pool-type"]))
            : _createCommentVNode("", true),
          (_ctx.poolType==='larix')
            ? (_openBlock(), _createBlock(_component_Dashboard, {
                key: 1,
                device: "PC",
                "page-type": _ctx.pageType,
                "pool-type": _ctx.poolType
              }, null, 8, ["page-type", "pool-type"]))
            : _createCommentVNode("", true),
          (_ctx.poolType==='stepn')
            ? (_openBlock(), _createBlock(_component_Dashboard, {
                key: 2,
                device: "PC",
                "page-type": _ctx.pageType,
                "pool-type": _ctx.poolType
              }, null, 8, ["page-type", "pool-type"]))
            : _createCommentVNode("", true),
          (_ctx.poolType==='step')
            ? (_openBlock(), _createBlock(_component_Dashboard, {
                key: 3,
                device: "PC",
                "page-type": _ctx.pageType,
                "pool-type": _ctx.poolType
              }, null, 8, ["page-type", "pool-type"]))
            : _createCommentVNode("", true),
          (_ctx.poolType==='bonfida'||_ctx.poolType==='main')
            ? (_openBlock(), _createBlock(_component_Dashboard, {
                key: 4,
                device: "PC",
                "page-type": _ctx.pageType,
                "pool-type": _ctx.poolType
              }, null, 8, ["page-type", "pool-type"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeRefresh())),
                style: {"cursor":"pointer"}
              }, [
                _createVNode(_component_q_circular_progress, {
                  size: "30px",
                  color: "blue",
                  value: _ctx.refreshProgress,
                  "track-color": "track"
                }, null, 8, ["value"])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t('supplyAndBorrow.borrowLimit')), 1),
                  _createVNode("img", {
                    src: _ctx.icon_information,
                    height: "14",
                    width: "14",
                    style: {"cursor":"pointer","position":"relative","top":"2px"}
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _createVNode("p", _hoisted_23, _toDisplayString(_ctx.t('tip.borrowLimitTip')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("p", _hoisted_24, _toDisplayString(_ctx.formatDollars(_ctx.userPoolBorrowLimit,2)), 1)
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t('positions.liquidationThreshol')), 1),
                  _createVNode("img", {
                    src: _ctx.icon_information,
                    height: "14",
                    width: "14",
                    style: {"cursor":"pointer","position":"relative","top":"2px"}
                  }, null, 8, ["src"]),
                  _createVNode(_component_q_tooltip, {
                    anchor: "center right",
                    self: "center left"
                  }, {
                    default: _withId(() => [
                      _createVNode("p", _hoisted_27, _toDisplayString(_ctx.t('tip.liquidationTip')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("p", _hoisted_28, _toDisplayString(_ctx.formatDollars(_ctx.userPoolLiquidationThreshold,2)), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_29, [
      _createVNode("div", _hoisted_30, [
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("div", null, _toDisplayString(_ctx.t('market.supplyBorrow')), 1),
              _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formatDollars(_ctx.allMarketSupplyAndBorrow.toString())), 1)
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", null, _toDisplayString(_ctx.t('market.totalSupply')), 1),
              _createVNode("div", _hoisted_36, _toDisplayString(_ctx.formatDollars(_ctx.poolTotalSupply.toString())), 1)
            ]),
            _createVNode("div", _hoisted_37, [
              _createVNode("div", null, _toDisplayString(_ctx.t('market.totalBorrow')), 1),
              _createVNode("div", _hoisted_38, _toDisplayString(_ctx.formatDollars(_ctx.poolTotalBorrow.toString())), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
})